<template>
    <section id="banner">
        <div class="conteudo-banner">
            <h1 class="texto-principal" data-aos="fade" data-aos-duration="1200">
                Seu estofado merece uma limpeza de verdade
            </h1>
            
            <p class="descricao-principal" data-aos="fade" data-aos-delay="200" data-aos-duration="1200">
                Higienização profissional para sofás, colchões, tapetes, cadeiras e muito mais
            </p>

            <p class="estrela" data-aos="fade" data-aos-delay="250" data-aos-duration="1200">★★★★★</p>

            <a data-aos="fade" data-aos-delay="300" data-aos-duration="1200" href="https://wa.me/5535999013609?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20fazer%20um%20or%C3%A7amento" target="_blank" class="button">Solicitar orçamento</a>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BannerLandingPage'
}
</script>

<style scoped>
#banner {
    height: 70vh;
    width: 100%;
    background-image: url('../assets/banner.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 80px;
    box-sizing: border-box;
}

#banner::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
}

.conteudo-banner {
    position: relative;
    z-index: 1;

    width: 90%;
    max-width: 1200px;
    margin: 0 auto;

    color: white;
}

.texto-principal {
    max-width: 700px;
    font-size: 52px;
    line-height: 1.1;
    margin: 0 0 20px;
    overflow: hidden;
}

.descricao-principal {
    max-width: 600px;
    font-size: 20px;
    line-height: 1.5;
    /* margin: 0 0 30px; */
}

.estrela{
    margin: 0 0 30px;
    font-size: 13px;
    opacity: 0.7;
    
}

.button {
    padding: 14px 28px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    background-color: var(--cor-tema);
    color: var(--cor-branco-texto);
    filter: drop-shadow(0 0 12px #80808148);
    text-decoration: none;
}

@media (min-width: 768px) and (max-width: 1200px){

}

@media (max-width: 600px) {
    .texto-principal{
        font-size: 46px;
        line-height: 60px;
        text-align: center;
    }

    .descricao-principal{
        text-align: center;
        font-size: 16px;
    }

    .conteudo-banner{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .button{
        font-size: 15px;
    }
}
</style>